const isValidURL = function (str) {
  try {
    return Boolean(new URL(str));
  } catch (e) {
    return false;
  }
};

const isValidEmail = function (str) {
  let regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;

  try {
    return Boolean(regex.text(str));
  } catch (e) {
    return false;
  }
};

const formatDropdownUnivResult = (data) => {
  if (!data.id) return data.text;
  return $(`
        <span class="font-weight-bolder">${data.text}</span>
        <span class="badge badge-primary ml-5">${data.country_name}</span>
    `);
};

const formatDropdownUnivSelection = (data) => {
  if (!data.id) return data.text;
  return $(`
        <span class="font-weight-bolder">${data.text}</span>
        <span class="badge badge-primary ml-5">${data.country_name}</span>
    `);
};

const initDefaultSelect2 = (
  is_ajax = false,
  ajaxData = null,
  element,
  elementDropdownParent = undefined,
  placeholder = "Choose",
  tags = false,
  allow_clear = false,
  is_search = true,
  searchValue = Infinity,
  isCustomTemplate = false,
  customTemplate = null
) => {
  let defaultConfig = {
    placeholder: placeholder,
  };
  if (elementDropdownParent !== undefined)
    defaultConfig.dropdownParent = elementDropdownParent;
  // if (customCssClass !== undefined) defaultConfig.dropdownCssClass = customCssClass
  if (tags) defaultConfig.tags = true;
  if (allow_clear) defaultConfig.allowClear = true;
  if (!is_search) defaultConfig.minimumResultsForSearch = searchValue;
  if (isCustomTemplate && customTemplate !== null) {
    switch (customTemplate) {
      case "university":
        defaultConfig.dropdownCssClass = "w-auto";
        defaultConfig.templateResult = formatDropdownUnivResult;
        defaultConfig.templateSelection = formatDropdownUnivResult;
        break;
    }
  }

  if (is_ajax) {
    defaultConfig.ajax = {
      url: ajaxData.endpoint,
      dataType: "json",
      type: "POST",
      data: function (params) {
        let dataParams = {
          q: params.term,
          page: params.page || 1,
        };
        if (ajaxData.data) {
          dataParams = {
            ...dataParams,
            ...ajaxData.data,
          };
        }
        return dataParams;
      },
      delay: 1000,
    };
  }
  $(element).select2(defaultConfig);
};

const makeKTBlock = (element, type = "show", bgColor = "#000") => {
  if (type == "show") {
    KTApp.block(element, {
      overlayColor: bgColor,
      type: "loader",
      state: "primary",
      opacity: 0.3,
      size: "lg",
      message: "Please wait...",
    });
  } else {
    KTApp.unblock(element);
  }
};

const makeSwal = (
  title,
  message,
  status,
  type = null,
  customWidth = null,
  redirect = null,
  outsideClickAble = true,
  contentDT = null
) => {
  if (type == "action") {
    Swal.fire({
      title: title,
      html: message,
      icon: status,
      confirmButtonText: "Close",
      confirmButtonColor: "#3699FF",
      customClass: { confirmButton: "btn btn-sm", cancelButton: "btn btn-sm" },
      allowOutsideClick: outsideClickAble,
      width: customWidth ? customWidth : "auto",
    }).then((result) => {
      if (redirect == "reload") {
        location.reload();
      } else if (redirect == "reload-dt") {
        contentDT.ajax.reload();
      } else if (redirect == "reload-kdt") {
        $(contentDT).KTDatatable("reload");
      } else if (redirect && redirect.startsWith("reload-tab#")) {
        const tabId = redirect.replace("reload-tab#", "");
        window.location.hash = tabId;
        location.reload();
      } else {
        window.location.href = redirect;
      }
    });
  } else {
    Swal.fire({
      title: title,
      html: message,
      icon: status,
      confirmButtonText: "Close",
      confirmButtonColor: "#3699FF",
      customClass: {
        confirmButton: "btn btn-sm",
      },
    });
  }
};

const makeNotify = (
  title,
  message,
  status,
  position = "bottom",
  align = "right",
  showDuration = 300,
  hideDuration = 1000,
  timeOut = 5000,
  extendedTimeOut = 1000
) => {
  let positionClass = "toast-" + position + "-" + align;
  toastr.options = {
    closeButton: true,
    debug: false,
    newestOnTop: true,
    progressBar: false,
    positionClass: positionClass,
    preventDuplicates: false,
    onclick: null,
    showDuration: showDuration,
    hideDuration: hideDuration,
    timeOut: timeOut,
    extendedTimeOut: extendedTimeOut,
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut",
  };

  if (status == "success") {
    toastr.success(message, title);
  } else if (status == "info") {
    toastr.info(message, title);
  } else if (status == "warning") {
    toastr.warning(message, title);
  } else {
    toastr.error(message, title);
  }
};

const ellipseText = (text, count, insertDots) => {
  return (
    text.slice(0, count) + (text.length > count && insertDots ? "..." : "")
  );
};

export {
  isValidURL,
  isValidEmail,
  initDefaultSelect2,
  makeKTBlock,
  makeSwal,
  makeNotify,
  ellipseText,
};
